import useApiClient from '../../../../../Base/Hooks/useApiClient';
import useNotification from '../../../../../../Hooks/useNotification.hook';
import { useDeleteWorkplaceMedicalProcedureMutation } from '../../../../../../graphql/graphql';
import ConfirmationModal from '../../../../../Base/Components/Confirmation/ConfirmationModal';
import Button from '../../../../../../Components/Button/Button';
import { Theme } from '../../../../../../Enums/Theme.enum';
import React from 'react';
import { BaseModalProps } from '../../../../../Base/Components/BaseModal/BaseModal';

interface Props extends BaseModalProps {
	id: string;
	reloadData: () => void;
}

const ManagerInsuranceCompaniesCaseTypeDeleteModal = ({
	id,
	reloadData,
	onClose,
	...modalProps
}: Props) => {
	const [deleteWorkplaceMedicalProcedure] =
		useDeleteWorkplaceMedicalProcedureMutation();
	const { displayGQLError } = useApiClient();
	const { showNotificationSuccess, showNotificationAlert } = useNotification();

	const handleDelete = async () => {
		try {
			const result = await deleteWorkplaceMedicalProcedure({ id });

			displayGQLError(result);
			if ('data' in result) {
				showNotificationSuccess({
					content: 'component.caseType.caseTypeDeleted',
				});
				reloadData();
				onClose();
			}
		} catch (error) {
			showNotificationAlert({
				content: 'base.shared.warningBug',
			});
		}
	};

	return (
		<ConfirmationModal
			{...modalProps}
			onClose={onClose}
			title={'component.caseType.deleteModalTitle'}
			text={'component.caseType.deleteModalText'}>
			<Button
				title={'base.shared.delete'}
				theme={Theme.RED}
				onClick={handleDelete}
			/>
		</ConfirmationModal>
	);
};

export default ManagerInsuranceCompaniesCaseTypeDeleteModal;
